
import { PropType, defineComponent, computed } from 'vue';
import { Pool } from '@/services/balancer/subgraph/types';
import { shorten } from '@/lib/utils';
import usePoolQuery from '@/composables/queries/usePoolQuery';
import usePool22Query from '@/composables/queries/usePool22Query';
import { JsTimeToDate } from '@/lib/utils/date';
import useWeb3 from '@/services/web3/useWeb3';
import usePoolSnapshotsQuery from '@/embr/composables/queries/usePoolSnapshotsQuery';
import useNumbers from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import tokenInfo from './tokenInfo.json';
import numeral from 'numeral';

export default defineComponent({
  props: {
    pool: {
      type: Object as PropType<Pool>,
      required: true
    },
    loading: { type: Boolean, default: false },
    titleTokens: { type: Object }
  },
  setup(props) {
    /**
     * STATE
     */
    const { explorerLinks } = useWeb3();
    const { priceFor } = useTokens();
    const { fNum } = useNumbers();
    const poolQuery = usePoolQuery(props.pool.id);
    const pool22Query = usePool22Query(props.pool.id);
    const poolSnapshotsQuery = usePoolSnapshotsQuery(props.pool.id, 7);
    const historicalPrices = computed(() => poolSnapshotsQuery.data.value?.prices);
    const history = computed(() => {
      if (!historicalPrices.value || Object.values(historicalPrices.value).length === 0) return [];

      const history = Object.keys(historicalPrices.value).map(timestamp => {
        if (!historicalPrices.value) return [];
        const price = historicalPrices.value[timestamp];
        return {
          timestamp: parseInt(timestamp),
          price
        };
      });
      return history;
    });
    const variation = computed(() => {
      let arrVariation = {};
      if (history.value.length === 0) return [];
      if (!props.pool.onchain) return [];
      Object.keys(props.pool.onchain.tokens).map((token, index: number) => {
        console.log('token', token);
        const currentPrice = priceFor(token);
        const startPrice = parseFloat(history.value[history.value.length - 1]['price'][index]);
        console.log('currentPrice', currentPrice);
        console.log('startPrice', startPrice);
        if (!startPrice) arrVariation[token] = 1.0;
        else {
          const variation: string = ((currentPrice - startPrice) / startPrice).toFixed(3);
          arrVariation[token] = variation;
        }
      });

      return arrVariation;
    });
    return {
      shorten,
      explorer: explorerLinks,
      JsTimeToDate,
      priceFor,
      fNum,
      numeral,
      poolQuery,
      pool22Query,
      tokenInfo,
      variation
    };
  }
});
